module.exports = __webpack_public_path__ + "img/19.88dddd55.png";